export default "__VITE_ASSET__Nyii1u5N__"